// extracted by mini-css-extract-plugin
module.exports = {"block_disc":"discription_block_disc__2w7Yo","wrapper_disc":"discription_wrapper_disc__4kn31"};